module.exports = __webpack_public_path__ + "img/ldd.5037eef2.png";